import {Component} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ListQuoteStandardWrapperComponent } from '@app/pages/quote/standard-quote/list-quote-standard/list-quote-standard-wrapper.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-list-quote-standard-desktop',
  templateUrl: './list-quote-standard-desktop.component.html',
  styleUrls: ['./list-quote-standard-desktop.component.css'],
})
export class ListQuoteStandardDesktopComponent extends ListQuoteStandardWrapperComponent {
  constructor(
    route: ActivatedRoute,
    menu: MenusServices,
    notification: NotificationService
  ) {
    super(route, menu, notification);
  }
}
